/**
 * Full content from PDF - Section 5 Configuration and API
 */
const C = (title, html) => ({ title, html });

export const content4 = {
  "5-1-1-engine": C(
    "5.1.1 X-Translator Engine",
    `<p>Object x_translator:</p>
<table><thead><tr><th>x_translator</th><th>Description</th></tr></thead>
<tbody>
<tr><td>x_load( P_PATH )</td><td>Load a saved mapping file</td></tr>
<tr><td>x_save( P_PATH )</td><td>Save a mapping file</td></tr>
<tr><td>e &lt;&lt; x_translator.new()<br>e.options &lt;&lt; l_options<br>e.source_spec &lt;&lt; l_source<br>e.target_spec &lt;&lt; l_target<br>e.mapping &lt;&lt; l_mapping</td><td>Create a x_translator object and initialise it with options, source, target and mapping.</td></tr>
<tr><td>e.log_dir &lt;&lt; l_dir</td><td>Optionally set log file directory to engine. The log directory is passed to x_translator_settings.log_console_path, log_error_path, log_statistics_path, log_history_path, log_dwg_path and the user application's report method</td></tr>
<tr><td>x_transfer()</td><td>Do the transfer</td></tr>
</tbody></table>`
  ),

  "5-1-2-specifications": C(
    "5.1.2 X-Translator Specification Classes",
    `<p>x_translator_xxx_target_spec/source_spec:</p>
<table><thead><tr><th>Method</th><th>Description</th></tr></thead>
<tbody>
<tr><td>new( P_PROPERTIES )</td><td>Creates a new specification object with the given properties.</td></tr>
<tr><td>get_property( P_KEY )</td><td>Returns a property</td></tr>
<tr><td>set_property(P_KEY, P_VALUE)</td><td>Sets a property</td></tr>
</tbody></table>
<p>The specification classes and their properties are documented in the reference manual.</p>`
  ),

  "5-1-3-mapping": C(
    "5.1.3 X-Translator Mapping",
    `<p>x_translator_mapping:</p>
<table><thead><tr><th>Method</th><th>Description</th></tr></thead>
<tbody>
<tr><td>new_with_properties(p_source_model, p_target_model, p_mapping_properties)</td><td>Simple creation of a mapping through mapping properties. See an example in the file cambridge_import.magik in the x_translator_cambridge module. Mapping of the source to the target model.</td></tr>
</tbody></table>`
  ),

  "5-1-4-options": C(
    "5.1.4 X-Translator Options",
    `<p>The x_translator_options class is used to configure settings for data transfer operations within the X-Translator engine. Options define behaviors such as exported attributes, coordinate transformations, or file-specific configurations.</p>
<table><thead><tr><th>x_translator_option</th><th>Description</th></tr></thead>
<tbody>
<tr><td>x_default_options()</td><td>Resets all options to their default values. Initializes all options to the system defaults.</td></tr>
<tr><td>x_get_option( P_KEY )</td><td>Retrieves the current value of an option identified by P_KEY.</td></tr>
<tr><td>x_set_option(P_KEY,P_VALUE)</td><td>Sets a specific option, identified by P_KEY, to the value P_VALUE.</td></tr>
</tbody></table>
<p>o1 uses the system-wide default options. o2 employs the customized options from custom_export_options() method.</p>`
  ),

  "5-1-5-error-handling": C(
    "5.1.5 Error Handling, Progress Conditions",
    `<p>A X-Translator transfer is divided into two parts:</p>
<ul>
<li><strong>x_open_read()/x_open_write():</strong> Tests if the transfer can be executed at all, e.g. if the target database is in write mode. The engine does not catch conditions (usually user errors), the user of the engine can react appropriately.</li>
<li><strong>x_transfer_engine():</strong> Does the actual data transfer. All conditions in this part are caught and logged as error or warning.</li>
</ul>
<p><strong>Progress conditions:</strong> x_progress_percent, x_progress_phase1/2/3 (Description of the transfer), x_information (thrown when a condition is caught).</p>`
  ),

  "5-1-6-dxf-api": C(
    "5.1.6 DXF-API",
    `<p>DXF-specific information can be returned to the RWO via the DXF API:</p>
<table><thead><tr><th>DXF-Properties</th><th>Description</th></tr></thead>
<tbody>
<tr><td>:dxf_layer</td><td>DXF Layer</td></tr>
<tr><td>:dxf_line_dashes</td><td>Line patterns according to the pattern "1" for solid or "5_5" for dashed</td></tr>
<tr><td>:dxf_style</td><td>DXF Text Style</td></tr>
<tr><td>:dxf_symbol_name</td><td>DXF Symbol Name</td></tr>
<tr><td>:dxf_line_width</td><td>DXF line width in pixels</td></tr>
<tr><td>:dxf_hatch_angle, :dxf_hatch_pitch</td><td>DXF Hatch</td></tr>
<tr><td>:dxf_fill_percent</td><td>DXF Filling Percent</td></tr>
<tr><td>:dxf_color, :dxf_color_name</td><td>The :dxf_color property requires an object of the class colour. For BYLAYER, set :dxf_color_name to :bylayer</td></tr>
</tbody></table>`
  ),

  "5-1-7-registered-attrs": C(
    "5.1.7 Registered Attributes",
    `<p>The register_translator_attribute() method allows you to register an additional attribute on a collection, which the X-Translator then offers like a normal field in the data model. The attribute is logical, its value is calculated on the object using a Magik method. The minimum required properties are: :category (:logical), :name (internal name), :external_name (external name), :type (e.g., :char, :int, :float), and :size (e.g., 40 for :char, 1 for numeric).</p>
<p>Example 1: Additional attribute with a formatted unit (e.g., coordinate as a string in meters).</p>
<p>Example 2: Exporting relations as an ID list (e.g., meter IDs of a house connection). See the admin manual for full code examples.</p>`
  ),

  "5-1-8-registered-geoms": C(
    "5.1.8 Registered Geometries",
    `<p>register_translator_geometry() works similarly, but registers an additional logical geometry (e.g., a calculated point or a line constructed from route coordinates). The geometry is provided via a Magik method on the object and treated like a normal geometry column in the export.</p>
<p>Example 1: Point geometry on an object, derived from a joined parent object.</p>
<p>Example 2: Line geometry (polyline), constructed from route coordinates. See the admin manual for full code examples.</p>`
  ),

  "5-2-1-export-mapping": C(
    "5.2.1 \"Export of a saved mapping\"",
    `<pre>x &lt;&lt; x_translator.new()
x.x_load( "C:\\temp\\export.xml" )
x.x_transfer()</pre>`
  ),

  "5-2-2-change-property": C(
    "5.2.2 \"Change the property of a specification object\"",
    `<pre>x &lt;&lt; x_translator.new()
x.x_load( "C:\\temp\\export.xml" )
x.target_spec.set_property(:path, "C:\\temp\\new_path.dxf" )
x.x_transfer()</pre>`
  ),

  "5-2-3-change-option": C(
    "5.2.3 \"Change the value of an option\"",
    `<pre>x &lt;&lt; x_translator.new()
x.x_load( "C:\\temp\\export.xml" )
x.options.x_set_option( :symbol_name_prefix, "a_" )
x.x_transfer()</pre>`
  ),

  "5-2-4-batch-import": C(
    "5.2.4 \"Batch Import of DWG/DXF files\"",
    `<pre>paths &lt;&lt; { "C:\\temp\\file1.dwg", "C:\\temp\\file2.dwg" }
x &lt;&lt; x_translator.new()
x.x_load( "C:\\temp\\import.xml" )
_for a_path _over paths.elements()
_loop
x.source_spec.set_property( :path, a_path)
x.x_transfer()
_endloop</pre>`
  ),

  "5-2-5-create-specs": C(
    "5.2.5 \"Create specifications from scratch\"",
    `<p>Create l_app, l_maps, l_display_style, l_scale, l_export_area, l_dir, l_path. Create l_options, l_world, l_source_spec (x_translator_smallworld_source_spec with :data_source, :ace_context, :visibility, :display_style_name, :export_area, :source_world, :csys_name, :unit_name), l_target_spec (x_translator_dxf_target_spec), l_mapping (x_translator_mapping.new()), l_engine. Set source_spec, target_spec, mapping, options, log_dir on engine. Call l_engine.x_transfer().</p>
<p>See the admin manual (page 43) for the full Magik code.</p>`
  ),

  "5-2-6-shape-to-oracle": C(
    "5.2.6 Importing a multi-part Shape file to Oracle",
    `<p>The following example discusses options for importing a Shape file with area geometry into Oracle Spatial geometry accessed through the Spatial SOM:</p>
<ol>
<li>Using a simple_area_set and a X-Translator User Application</li>
<li>Using the Explode geometries into multiple objects on import (needs sys_id) option together with a fire_pre_insert_actions() method</li>
</ol>
<p>The Shape area can consist of multiple "parts" which must be taken care of during the import to not lose any data.</p>
<p><strong>Using a simple_area_set and a X-Translator User Application:</strong> Define instance metadata with coverages as simple_area_set. Register a user application with model method that adds genid attribute and convert_feature method. The genid attribute can be used in the mapping.</p>
<p><strong>Using the explode geometries option with fire_pre_insert_actions():</strong> Select the option in the Smallworld target options and map to the coverage geometry. Use fire_pre_insert_actions() to set the id from sw_gis!spatial_id.get().</p>
<p>See the admin manual (pages 44-46) for full code examples.</p>`
  ),

  "5-3-1-overview": C(
    "5.3.1 Overview",
    `<p>The SEPM X-Translator offers flexible configuration possibilities, which allow rapid implementation of specific requirements.</p>
<p>The User Application feature is a powerful tool to control the transfer process in many ways:</p>
<ul>
<li>"Enhancement" of the source data model (target collection names, case coordinate, style information, etc.)</li>
<li>Definition of "DXF Information" (DXF layer, linetype, color, text style, block name)</li>
<li>Custom Insert/Update API</li>
<li>Definition of logical attributes or geometries calculated on the fly</li>
<li>Definition of logical collections in the Smallworld source (export two or more source collections into one target)</li>
<li>Definition of a report method for custom reports</li>
<li>Definition of methods called before/after reading/writing a dataset, collection or feature</li>
</ul>`
  ),

  "5-3-2-properties": C(
    "5.3.2 Properties",
    `<p><strong>User Application (x_translator_user_application):</strong> name, external_name, is_hidden, source_formats, target_formats, engine_exemplar, model_method, report_method, additional_objects_method, additional_geometries_method.</p>
<p><strong>x_translator_model_collection:</strong> convert_feature_method, user_method (for DXF info: :dxf_layer, :dxf_linetype, :dxf_color, :dxf_line_width, :dxf_style, :dxf_symbol_name).</p>`
  ),

  "5-3-3-example": C(
    "5.3.3 Example",
    `<p>The file cambridge_export.magik in the module x_translator_cambridge contains an example of a user application.</p>
<p>Register a user application with name :cambridge, model_method, report_method, target_path_method.</p>
<p>Model method: Do arbitrary changes to the source model, define logical collections with convert_feature_method, register DXF API methods with user_method, define logical attributes or geometries with method_name.</p>
<p>The registered methods (cambridge_user_method, my_string, my_coverage) return property_list with :dxf_layer, :dxf_linetype, :dxf_color, etc. or the computed value.</p>
<p>See the admin manual (pages 49-50) for full code examples.</p>`
  ),
};
